<template>
  <div class="study-details">
    <!-- <div class="scroll-content"> -->
    <div class="student-information">
      <div class="avatar">
        <img v-if="studentInfo.student.gender === 1" src="../../../assets/images/avator-woman.png" class="img-avator-woman" draggable="false" />
        <img v-else src="../../../assets/images/avator-man.png" class="img-avator-man" draggable="false" />
      </div>
      <div class="infos">
        <div class="header">
          <div class="left">
            <span>{{studentInfo.student.name}}</span>
            <img v-if="studentInfo.student.gender === 1" src="../../../assets/images/woman.png" class="img-avator-gender" draggable="false" />
            <img v-else src="../../../assets/images/man.png" class="img-avator-gender" draggable="false" />
          </div>
          <div class="right">
            <img src="../../../assets/images/alarm-clock.png" class="img-last-login-time" draggable="false" />
            <span>上次登录时间：{{studentInfo.student.loginTime || '&nbsp;'}}</span>
          </div>
        </div>
        <div class="content">
          <div class="info">专业：<span class="black">{{studentInfo.student.profressionName}}</span></div>
          <div class="info">学号：<span class="black">{{studentInfo.student.gender === 1 ? '女' : '男'}}</span></div>
          <div class="info">手机：<span class="black">{{studentInfo.student.account}}</span></div>
        </div>
      </div>
    </div>
    <div class="scroll-content">
      <div class="title-card">
        <div class="card-header">
          <div class="bar"></div>
          <div class="title">AI评价内容</div>
        </div>
        <div class="card-content ai-evaluation-content">
          <div v-if="aiEvaluationLoading" class="ai-eval-streaming">
            <span class="ai-eval-content">{{formattedEvaluation}}</span><span class="ai-eval-cursor">▋</span>
          </div>
          <div v-else-if="aiEvaluationContent" class="ai-eval-content">{{formattedEvaluation}}</div>
          <div v-else-if="aiEvaluationError" class="ai-eval-error">{{aiEvaluationError}}</div>
          <div v-else class="empty-tip">暂无AI评价</div>
        </div>
      </div>
      <!-- 学生画像：任务点学习统计 + 学生个人能力画像（数据来自 portrait 接口，每日凌晨定时任务快照） -->
      <div class="portrait-row">
        <div class="title-card portrait-task-card">
          <div class="card-header">
            <div class="bar"></div>
            <div class="title">任务点学习统计</div>
            <div class="tips" v-if="studentInfo.user.updateTime">最近提交时间：{{formatDate(studentInfo.user.updateTime)}}（该学习进度将于每日凌晨更新~）</div>
          </div>
          <div class="card-content">
            <div class="task-progress-grid">
              <div class="progress-item" v-for="(option, key) in chartsOptions" :key="key">
                <div class="num">
                  {{option.describeData.data}}
                </div>
                <div class="label">{{option.describeData.title}}</div>
                <div class="bar-track">
                  <div class="bar-fill" :style="{width: option.chartData + '%'}"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="title-card portrait-ability-card">
          <div class="card-header">
            <div class="bar"></div>
            <div class="title">学生个人能力画像</div>
          </div>
          <div class="card-content">
            <div class="ability-body">
              <div class="radar-wrap">
                <div v-show="hasAbilityData" ref="abilityRadar" class="ability-radar"></div>
                <div v-if="!hasAbilityData" class="ability-empty">暂无足够答题数据</div>
                <div class="radar-legend">
                  <span class="lg"><i class="dot dot-blue"></i>答题量指数</span>
                  <span class="lg"><i class="dot dot-orange"></i>正确率</span>
                </div>
              </div>
              <div class="ability-table">
                <div class="at-title">各系统答题量与正确率明细</div>
                <div class="at-row" v-for="(row, index) in abilityRows" :key="index">
                  <span class="at-name">{{row.chapterName}}</span>
                  <span class="at-num">{{row.answerNum}}题</span>
                  <span class="at-rate" :style="{color: row.color}">{{row.accuracyRate}}%</span>
                </div>
                <div v-if="!abilityRows.length" class="at-empty">暂无数据</div>
                <!-- <div v-if="insufficientTip" class="at-tip">{{insufficientTip}}</div> -->
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="title-card">
        <!-- <div class="card-header">
          <div class="bar"></div>
          <div class="title">任务点学习统计</div>
          <div class="tips">最近提交时间：{{formatDate(studentInfo.user.updateTime)}}（该学习进度将于每日凌晨更新~）</div>
        </div> -->
        <div class="card-content learning-statistics-content">
          <!-- <div class="analysis-content">
            <div class="annular-panel" v-for="(option, key) in chartsOptions" :key="key">
              <div class="panel-pie-chart">
                <div class="pie-chart"
                  :style="{
                    '--progress': `${option.chartData}%`,
                    '--start--color': option.colorSchemes.finished,
                    '--end--color': option.colorSchemes.unfinished
                  }"
                ></div>
              </div>
              <div class="panel-describe" :style="{color: option.describeData.color}">
                <div class="title">{{option.describeData.title}}</div>
                <div class="data">{{option.describeData.data}}</div>
              </div>
            </div>
          </div> -->
          <div class="task-table">
            <div class="search-panel">
              <el-form ref="taskSearchForm" :model="taskSearchForm" inline>
                <el-form-item prop="name">
                  <el-select style="width:160px; marginLeft: 13px" v-model="taskSearchForm.taskType" placeholder="请选择" size="small">
                    <el-option label="任务点小节" :value="1" ></el-option>
                    <el-option label="非任务点小节" :value="0" ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item  prop="class">
                  <el-input v-model="taskSearchForm.name" placeholder="搜索小节序号或名称" clearable size="medium">
                    <i slot="prefix" class="el-input__icon el-icon-search"></i>
                  </el-input>
                </el-form-item>
                <el-form-item>
                  <div class="search-btn" @click="taskSearch()" >搜索</div>
                </el-form-item>
              </el-form>
            </div>
            <div class="table-study-detail">
              <el-table ref="studyTable" :height="studyTableHeight" :data="studyTableData.list"
                border :header-cell-style="{background:'#EBF3FF', color:'#4F6389'}"
                @sort-change="handleSortChange"
              >
                <el-table-column prop="levelPath" label="小节名称" sortable='custom'>
                  <template v-slot="{ row }">
                    {{row.levelPath +'&nbsp;'+ row.directoryName}}
                  </template>
                </el-table-column>
                <el-table-column label="视频完成进度" align="center">
                  <template v-slot="{ row }">
                    <div v-if="!row.videoStatus">/</div>
                    <div v-else class="table-charts-panel">
                      <div class="table-pie-chart">
                        <div class="pie-chart" :style="{ '--progress': `${row.videoRate}%` }"></div>
                      </div>
                      <div class="table-pie-data">{{row.videoRate}}%</div>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column label="理论题正确率" align="center">
                  <template v-slot="{ row }">
                    <div v-if="!row.questionStatus">/</div>
                    <div v-else class="table-charts-panel">
                      <div class="table-bar-chart">
                        <div class="bar-chart" :style="{width: `${row.questionRate}%`}"></div>
                      </div>
                      <div class="table-bar-data">{{row.questionRate}}%</div>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column label="病例题正确率（影像学表现/诊断）" align="center" width="360px">
                  <template v-slot="{ row }">
                    <div v-if="!row.studyStatus">/</div>
                    <div v-else class="table-charts-panel">
                      <div class="table-bar-chart">
                        <div class="bar-chart" :style="{width: `${row.studyFindRate}%`}"></div>
                      </div>
                      <div class="table-bar-data">{{row.studyFindRate}}%</div>
                      <div class="table-bar-chart">
                        <div class="bar-chart" :style="{width: `${row.studyRate}%`}"></div>
                      </div>
                      <div class="table-bar-data">{{row.studyRate}}%</div>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column prop="updateTime" label="本节最近提交时间" sortable align="center">
                  <template slot-scope="{ row }"><span>{{ formatDate(row.updateTime) }}</span></template>
                </el-table-column>
              </el-table>
              <div class="pagination-panel">
                <el-pagination
                  :current-page="studyTableData.pagination.currentPage"
                  :page-size="studyTableData.pagination.pageSize"
                  :page-sizes="[5, 10, 20, 30, 40, 50]"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="studyTableData.pagination.total"
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                  background
                ></el-pagination>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="title-card">
        <div class="card-header">
          <div class="bar"></div>
          <div class="title">考试成绩</div>
        </div>
        <div class="card-content exam-score-content">
          <div class="score-table">
            <el-table ref="scoreTableList" :height="scoreTableHeight" :data="scoreTableData" border
              :header-cell-style="{background:'#EBF3FF', color:'#4F6389'}" class="study-detail-table" >
              <el-table-column prop="studentNo" label="考试名称" align="center"></el-table-column>
              <el-table-column prop="name" label="考试开始时间" align="center"></el-table-column>
              <el-table-column prop="name" label="考试用时" align="center"></el-table-column>
              <el-table-column prop="account" label="考试提交时间" align="center"></el-table-column>
              <el-table-column prop="account" label="考试分数" align="center" width="360px"></el-table-column>
              <el-table-column label="本场考试排名" align="center">
                <template slot-scope="{ row }"><span>{{ formatDate(row.createTime) }}</span></template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import { comMethod } from '@/utils/index.js'
import { formatDate } from '@/utils/formatDate.js';
import { studentCenterServer } from '@/api/api';
import * as echarts from 'echarts';
export default {
  name: 'StudyDetails',
  data () {
    return {
      studentId: this.$route.query.id,
      studentInfo: {
        student: {},
        total: {},
        user: {}
      },
      // 图表
      chartsOptions: {
        subsection: {
          chartData: '',
          describeData: {
            title: '小节进度',
            data: '',
            color: '#D48806'
          },
          colorSchemes: { // 黄
            finished: '#FFD067',
            unfinished: '#f9e7b7',
          }
        },
        video: {
          chartData: '',
          describeData: {
            title: '视频进度',
            data: '',
            color: '#08979C'
          },
          colorSchemes: { // 青
            finished: '#13C2C2',
            unfinished: '#CBE8EE',
          }
        },
        theory: {
          chartData: '',
          describeData: {
            title: '理论题进度',
            data: '',
            color: '#003CAB'
          },
          colorSchemes: { // 蓝
            finished: '#366EF4',
            unfinished: '#bac7ef',
          }
        },
        illness: {
          chartData: '',
          describeData: {
            title: '病例题进度',
            data: '',
            color: '#531DAB'
          },
          colorSchemes: { // 紫
            finished: '#722ED1',
            unfinished: '#EFDBFF',
          }
        }
      },
      taskSearchForm: {
        taskType: 1,
        name: ''
      },
      studyTableData: {
        list: [],
        pagination: {
          currentPage: 1,
          pageSize: 10,
          total: 0
        }
      },
      studyTableHeight: 351,
      // scoreTableHeight: 105,
      // scoreTableHeight: 255,
      scoreTableHeight: 133,
      scoreTableData: [],
      studyTableSort: {
        sortType: 1,
        sort: 0
      },
      aiEvaluationContent: '',
      aiEvaluationLoading: false,
      aiEvaluationError: '',
      aiStreamReader: null,
      // 学生画像 - 任务点学习统计
      // portraitTask: {
      //   section: {},
      //   video: {},
      //   question: {},
      //   study: {},
      //   statTime: ''
      // },
      // 学生画像 - 能力画像雷达图
      abilityRadarData: {
        chapters: [],
        omitted: [],
        insufficient: [],
        minAnswerNum: 5,
        minCohortNum: 10,
        maxAxes: 8
      },
      abilityChart: null
    }
  },
  computed: {
    // 任务点学习统计 4 项进度（小节/视频/理论题/病例题）
    // portraitTaskItems () {
    //   const task = this.portraitTask || {};
    //   const list = [
    //     { key: 'section', title: '小节进度', data: task.section },
    //     { key: 'video', title: '视频进度', data: task.video },
    //     { key: 'question', title: '理论题进度', data: task.question },
    //     { key: 'study', title: '病例题进度', data: task.study }
    //   ];
    //   return list.map(item => {
    //     const detail = item.data || {};
    //     return {
    //       key: item.key,
    //       title: item.title,
    //       finishNum: detail.finishNum || 0,
    //       totalNum: detail.totalNum || 0,
    //       rate: Number(detail.rate) || 0,
    //       hasContent: detail.hasContent !== false
    //     };
    //   });
    // },
    // portraitStatTimeText () {
    //   return this.portraitTask.statTime ? formatDate(this.portraitTask.statTime).slice(0, 16) : '';
    // },
    hasAbilityData () {
      return !!(this.abilityRadarData.chapters && this.abilityRadarData.chapters.length);
    },
    // 各系统答题量与正确率明细（顺序与雷达图轴一致，按答题量降序）
    abilityRows () {
      return (this.abilityRadarData.chapters || []).map(chapter => ({
        chapterName: chapter.chapterName,
        answerNum: chapter.answerNum || 0,
        accuracyRate: Number(Number(chapter.accuracyRate || 0).toFixed(2)),
        color: this.rateColor(chapter.accuracyRate)
      }));
    },
    // 流式文本排版：在「N. 」/「N、」这类分节标题前补一个换行（流里常常不带换行）
    // 仅当标题前是非换行字符时才补，避免影响「1. 总体印象」首行与「56.6%」这类数字
    formattedEvaluation () {
      if (!this.aiEvaluationContent) return '';
      return this.aiEvaluationContent.replace(/([^\n])(\d+[.、]\s)/g, '$1\n$2');
    },
    insufficientTip () {
      const list = this.abilityRadarData.insufficient || [];
      if (!list.length) return '';
      const threshold = this.abilityRadarData.minAnswerNum != null ? this.abilityRadarData.minAnswerNum : 5;
      return `数据不足（答题量 < ${threshold}）：` + list.map(item => item.chapterName).join('、');
    }
  },
  created () {
    this.getStudyTableData();
    this.getStudentInformation();
    this.getAiEvaluation();
    // this.getPortraitTaskPointStat();
    this.getPortraitAbilityRadar();
    // this.studyTableHeight = comMethod.getTableHeight(594);
  },
  beforeDestroy () {
    this.closeAiStream();
    window.removeEventListener('resize', this.resizeAbilityRadar);
    if (this.abilityChart) {
      this.abilityChart.dispose();
      this.abilityChart = null;
    }
  },
  methods: {
    formatDate,
    async getStudyTableData(currentPage = 1) {
      try {
        const backendParams = {
          userId: this.studentId,
          ...this.taskSearchForm,
          page: currentPage,
          rows: this.studyTableData.pagination.pageSize,
          sortType: this.studyTableSort.sortType, 
          sort: this.studyTableSort.sort
        };
        const res = await studentCenterServer.studentAnalysisChapterList({...backendParams});
        const { code, data, message } = res;
        if (code === '0') {
            const list = data ? data.records : [];
            const total = data ? data.total : 0;
            this.studyTableData.list = list;
            this.studyTableData.pagination.total = total;
        } else {
          this.$message.error(message);
        }
      } catch (error) {
        this.$message.error(error);
      }
    },
    async getStudentInformation() {
      try {
        const backendParams = {
          userId: this.studentId,
        };
        const res = await studentCenterServer.studentAnalysisDetail({ ...backendParams });
        const { code, data, message } = res;
        if (code === '0') {
          this.studentInfo = data;
          this.setChartsOptions(data.user, data.total);
        } else {
          this.$message.error(message);
        }
      } catch (error) {
        this.$message.error(error);
      }
    },
    async getAiEvaluation() {
      this.closeAiStream();
      this.aiEvaluationLoading = true;
      this.aiEvaluationContent = '';
      this.aiEvaluationError = '';
      const token = localStorage.getItem('token') || '';
      const url = `/api/college_manage/student/aiEvaluation?userId=${encodeURIComponent(this.studentId)}`;
      try {
        const response = await fetch(url, {
          method: 'POST',
          headers: {
            'Authorization': token,
            'Accept': 'text/event-stream'
          },
          credentials: 'include'
        });
        if (!response.ok) {
          throw new Error(`请求失败（${response.status}）`);
        }
        const reader = response.body.getReader();
        const decoder = new TextDecoder('utf-8');
        this.aiStreamReader = reader;
        let buffer = '';
        // 逐行解析 SSE：服务端把单个 data 字段的值跨多行发送
        // （首行带 "data:" 前缀，后续延续行不带前缀），按 SSE 规范这些行需用 \n 连接。
        // 事件之间没有空行分隔，而是以新的 "event:" 字段作为边界。
        let dataLines = [];
        const flushEvent = () => {
          if (!dataLines.length) return;
          const dataStr = dataLines.join('\n');
          dataLines = [];
          const chunk = this.parseSseData(dataStr);
          if (chunk !== null) {
            this.aiEvaluationContent += chunk;
          }
        };
        while (true) {
          const { done, value } = await reader.read();
          if (done) break;
          buffer += decoder.decode(value, { stream: true });
          let nlIdx;
          while ((nlIdx = buffer.indexOf('\n')) !== -1) {
            const rawLine = buffer.slice(0, nlIdx).replace(/\r$/, '');
            buffer = buffer.slice(nlIdx + 1);
            if (rawLine === '') {
              // 空行：当前事件结束（标准 SSE 事件分隔）
              flushEvent();
              continue;
            }
            if (rawLine.charAt(0) === ':') continue; // 注释行
            if (/^event\s*:/.test(rawLine)) {
              // 新 event 字段出现 = 上一个事件结束（兼容服务端无空行分隔的情况）
              flushEvent();
              continue;
            }
            if (/^(id|retry)\s*:/.test(rawLine)) continue; // 其他控制字段
            if (rawLine.indexOf('data:') === 0) {
              // data 字段：只去掉 "data:" 前缀，保留正文自带内容（含前导空格）
              dataLines.push(rawLine.slice(5));
            } else {
              // 无前缀的延续行：属于上一个 data 字段的下一行，join('\n') 会在中间补 \n
              dataLines.push(rawLine);
            }
          }
        }
        // 流结束：处理缓冲区残留的最后一行 + 派发最后一个事件
        if (buffer.replace(/\r$/, '') !== '') {
          const lastLine = buffer.replace(/\r$/, '');
          if (lastLine.indexOf('data:') === 0) dataLines.push(lastLine.slice(5));
          else dataLines.push(lastLine);
        }
        flushEvent();
        this.aiEvaluationLoading = false;
        this.aiStreamReader = null;
      } catch (error) {
        this.aiEvaluationLoading = false;
        this.aiStreamReader = null;
        if (error && error.name === 'AbortError') return;
        this.aiEvaluationError = (error && error.message) ? error.message : '获取AI评价失败';
      }
    },
    parseSseData (dataStr) {
      // 入参已是按 SSE 规范拼接好的单个 data 字段值（多行 data 已用 \n 连接）
      if (!dataStr || !dataStr.trim()) return null;
      if (dataStr.trim() === '[DONE]') return null;
      try {
        const json = JSON.parse(dataStr);
        if (typeof json === 'string') return json;
        if (json && json.content != null) return String(json.content);
        if (json && json.choices && json.choices[0] && json.choices[0].delta && json.choices[0].delta.content != null) {
          return String(json.choices[0].delta.content);
        }
        return JSON.stringify(json);
      } catch (e) {
        return dataStr;
      }
    },
    closeAiStream () {
      if (this.aiStreamReader) {
        try { this.aiStreamReader.cancel(); } catch (e) {}
        this.aiStreamReader = null;
      }
    },
    // 正确率 -> 绿色深浅（0% 浅绿 #95DE64，100% 深绿 #237804）
    // 正确率分档着色：>70% 绿色，<60% 红色，60%~70% 黄色
    rateColor (value) {
      const val = Number(value) || 0;
      if (val > 70) return '#52C41A';
      if (val < 60) return '#F5222D';
      return '#FAAD14';
    },
    // 任务点学习统计（每日凌晨定时任务快照）
    // async getPortraitTaskPointStat () {
    //   try {
    //     const res = await studentCenterServer.portraitTaskPointStat({ userId: this.studentId });
    //     const { code, data } = res;
    //     if (code === '0' && data) {
    //       this.portraitTask = {
    //         section: data.section || {},
    //         video: data.video || {},
    //         question: data.question || {},
    //         study: data.study || {},
    //         statTime: data.statTime || ''
    //       };
    //     }
    //   } catch (error) {
    //     console.error('任务点学习统计获取失败：', error);
    //   }
    // },
    // 能力画像雷达图
    async getPortraitAbilityRadar () {
      try {
        const res = await studentCenterServer.portraitAbilityRadar({ userId: this.studentId });
        const { code, data } = res;
        if (code === '0' && data) {
          this.abilityRadarData = {
            chapters: data.chapters || [],
            omitted: data.omitted || [],
            insufficient: data.insufficient || [],
            minAnswerNum: data.minAnswerNum != null ? data.minAnswerNum : 5,
            minCohortNum: data.minCohortNum != null ? data.minCohortNum : 10,
            maxAxes: data.maxAxes != null ? data.maxAxes : 8
          };
          this.$nextTick(() => this.renderAbilityRadar());
        }
      } catch (error) {
        console.error('能力画像获取失败：', error);
      }
    },
    renderAbilityRadar () {
      const el = this.$refs.abilityRadar;
      if (!el || !this.hasAbilityData) return;
      if (this.abilityChart) {
        this.abilityChart.dispose();
        this.abilityChart = null;
      }
      this.abilityChart = echarts.init(el);
      this.abilityChart.setOption(this.buildAbilityRadarOption());
      window.addEventListener('resize', this.resizeAbilityRadar);
    },
    resizeAbilityRadar () {
      if (this.abilityChart) this.abilityChart.resize();
    },
    buildAbilityRadarOption () {
      const chapters = this.abilityRadarData.chapters || [];
      const maxAnswerNum = Math.max(...chapters.map(item => Number(item.answerNum) || 0), 1);
      // 答题量指数：接口未直接提供，前端按「本章节答题量 / 最大答题量 * 100」归一化到 0~100
      const volumeData = chapters.map(item => Number(((Number(item.answerNum) || 0) / maxAnswerNum * 100).toFixed(2)));
      // 正确率：按接口约定统一使用 abilityScore 绘图
      const accuracyData = chapters.map(item => Number(Number(item.abilityScore || 0).toFixed(2)));
      return {
        tooltip: {
          trigger: 'item'
        },
        radar: {
          center: ['50%', '52%'],
          radius: '62%',
          splitNumber: 4,
          indicator: chapters.map(item => ({ name: item.chapterName, max: 100 })),
          axisName: { color: '#4F6389', fontSize: 12, fontFamily: 'PingFang SC' },
          splitLine: { lineStyle: { color: '#E1EBF6' } },
          splitArea: { areaStyle: { color: ['#FFFFFF', '#F7F9FC'] } },
          axisLine: { lineStyle: { color: '#E1EBF6' } }
        },
        series: [
          {
            type: 'radar',
            symbol: 'circle',
            symbolSize: 5,
            emphasis: { focus: 'self' },
            data: [
              {
                value: volumeData,
                name: '答题量指数',
                lineStyle: { color: '#366EF4', width: 2 },
                itemStyle: { color: '#366EF4' },
                areaStyle: { color: 'rgba(54,110,244,0.20)' }
              },
              {
                value: accuracyData,
                name: '正确率',
                lineStyle: { color: '#FAAD14', width: 2 },
                itemStyle: { color: '#FAAD14' },
                areaStyle: { color: 'rgba(250,173,20,0.20)' }
              }
            ]
          }
        ]
      };
    },
    setChartsOptions(user, total) {
      this.chartsOptions.subsection.chartData = total.sectionNum !== 0 ? (user.sectionNum / total.sectionNum *100).toFixed(2) : 0;
      this.chartsOptions.video.chartData = total.videoNum !== 0 ? (user.videoNum / total.videoNum *100).toFixed(2) : 0;
      this.chartsOptions.theory.chartData = total.questionNum !== 0 ? (user.questionNum / total.questionNum *100).toFixed(2) : 0;
      this.chartsOptions.illness.chartData = total.studyNum !== 0 ? (user.studyNum / total.studyNum *100).toFixed(2) : 0;
      this.chartsOptions.subsection.describeData.data = `${user.sectionNum}/${total.sectionNum}` || '0/0';
      this.chartsOptions.video.describeData.data = `${user.videoNum}/${total.videoNum}` || '0/0';
      this.chartsOptions.theory.describeData.data = `${this.chartsOptions.theory.chartData}%`;
      this.chartsOptions.illness.describeData.data = `${user.studyNum}/${total.studyNum}` || '0/0';
    },
    taskSearch (currentPage = 1) {
      this.getStudyTableData(currentPage);
    },
    // pageSize 改变时会触发
    handleSizeChange (val) {
      this.studyTableData.pagination.pageSize = val;
      this.studyTableData.pagination.currentPage = 1;
      this.taskSearch();
    },
    // currentPage 改变时会触发
    handleCurrentChange (currentPage) {
      this.studyTableData.pagination.currentPage = currentPage
      this.taskSearch(currentPage);
    },
    handleSortChange({prop, order}) {
      this.studyTableData.pagination.currentPage = 1;
      this.studyTableSort.sortType = prop === 'levelPath' ? 0 : 1;
      this.studyTableSort.sort = order === 'ascending' ? 1 : 0;
      this.taskSearch();
    }
  }
}
</script>

<style lang="scss" scoped>
.study-details {
  width: 100%;
  overflow-y: auto;
  border-radius: 16px;
  padding: 24px 4px;
  background: rgba(255, 255, 255, 0.8);
  .student-information {
    margin: 0 20px;
    height: 88px;
    width: calc(100% - 40px);
    display: flex;
    border-bottom: 2px solid #E1EBF6;
    .avatar {
      height: 72px;
      width: 72px;
      margin-right: 25px;
      .img-avator-woman {
        height: 100%;
        width: 100%;
      }
      .img-avator-man {
        height: 100%;
        width: 100%;
      }
    }
    .infos {
      width: calc(100% - 97px);
      margin-top: 10px;
      .header {
        display: flex;
        justify-content: space-between;
        .left {
          font-size: 22px;
          font-weight: bold;
          color: #000000;
          display: flex;
          align-items: center;
          .img-avator-gender {
            width: 18px;
            height: 18px;
            margin-left: 8px;
          }
          span {
            font-family: AlimamaShuHeiTi;
          }
        }
        .right {
          display: flex;
          align-items: center;
          font-family: PingFang SC;
          font-size: 16px;
          font-weight: normal;
          .img-last-login-time {
            width: 16px;
            height: 16px;
            margin-right: 6px;
          }
          span {
            font-family: PingFang SC;
          }
        }
      }
      .content {
        margin-top: 6px;
        display: flex;
        .info {
          font-size: 16px;
          margin-right: 16px;
          font-family: PingFang SC;
          .black {
            font-family: PingFang SC;
            color: #000000;
          }
        }
      }
    }
  }
  .scroll-content {
    height: calc(100vh - 206px);
    overflow-y: auto;
    padding: 0 20px;
    .title-card {
      .card-header {
        height: 42px;
        display: flex;
        align-items: center;
        .bar {
          width: 4px;
          height: 16px;
          border-radius: 40px;
          background: #0052D9;
          margin-right: 8px;
        }
        .title {
          font-family: AlimamaShuHeiTi;
          font-size: 18px;
          font-weight: bold;
          color: #000000;
        }
        .tips {
          font-family: PingFang SC;
          font-size: 14px;
          font-weight: normal;
          color: #4F6389;
          margin-left: 16px;
        }
      }
      .card-content {
        background: #FFFFFF;
        border-radius: 16px;
      }
    }
    // 学生画像：左右两张卡片
    .portrait-row {
      display: flex;
      align-items: stretch;
      margin-bottom: 16px;
      > .title-card {
        flex: 1 1 0;
        min-width: 0;
        display: flex;
        flex-direction: column;
        > .card-content {
          flex: 1 1 auto;
          min-height: 0;
        }
      }
      .portrait-task-card {
        margin-right: 16px;
      }
      // 任务点学习统计
      .task-progress-grid {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        grid-gap: 12px;
        padding: 16px;
        .progress-item {
          background: #F7F9FC;
          border: 1px solid #E9EFF7;
          border-radius: 8px;
          padding: 12px 16px 14px;
          text-align: left;
          .num {
            font-family: AlimamaShuHeiTi, PingFang SC;
            font-size: 26px;
            font-weight: bold;
            line-height: 34px;
            color: #2B5EEF;
          }
          .num.empty {
            font-size: 16px;
            font-weight: normal;
            color: #AAB4D2;
          }
          .label {
            font-family: PingFang SC;
            font-size: 14px;
            color: #4F6389;
            margin-top: 2px;
          }
          .bar-track {
            height: 6px;
            border-radius: 3px;
            background: #E3EAFB;
            margin-top: 12px;
            overflow: hidden;
            .bar-fill {
              height: 100%;
              border-radius: 3px;
              background: #2B5EEF;
              transition: width 0.3s;
            }
          }
        }
      }
      // 学生个人能力画像
      .ability-body {
        display: flex;
        align-items: flex-start;
        padding: 8px 16px 16px;
        .radar-wrap {
          flex: 0 0 52%;
          max-width: 52%;
          display: flex;
          flex-direction: column;
          align-items: center;
          .ability-radar {
            width: 100%;
            height: 210px;
          }
          .ability-empty {
            width: 100%;
            height: 210px;
            display: flex;
            align-items: center;
            justify-content: center;
            color: #AAB4D2;
            font-family: PingFang SC;
            font-size: 14px;
          }
          .radar-legend {
            display: flex;
            align-items: center;
            margin-top: 4px;
            font-family: PingFang SC;
            font-size: 12px;
            color: #4F6389;
            .lg {
              display: flex;
              align-items: center;
              margin: 0 8px;
            }
            .dot {
              display: inline-block;
              width: 10px;
              height: 10px;
              border-radius: 2px;
              margin-right: 6px;
            }
            .dot-blue {
              background: #366EF4;
            }
            .dot-orange {
              background: #FAAD14;
            }
          }
        }
        .ability-table {
          flex: 1 1 0;
          min-width: 0;
          padding-left: 16px;
          text-align: left;
          .at-title {
            font-family: PingFang SC;
            font-size: 14px;
            font-weight: 600;
            color: #000000;
            margin-bottom: 6px;
          }
          .at-row {
            display: flex;
            align-items: center;
            height: 34px;
            border-bottom: 1px solid #F0F4FA;
            font-family: PingFang SC;
            font-size: 14px;
            color: #333333;
            .at-name {
              flex: 1 1 0;
              min-width: 0;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
            .at-num {
              flex: 0 0 72px;
              text-align: right;
              color: #4F6389;
            }
            .at-rate {
              flex: 0 0 64px;
              text-align: right;
              font-weight: 600;
            }
          }
          .at-tip {
            margin-top: 8px;
            font-family: PingFang SC;
            font-size: 12px;
            color: #AAB4D2;
            line-height: 1.5;
          }
          .at-empty {
            padding: 24px 0;
            text-align: center;
            color: #AAB4D2;
            font-family: PingFang SC;
            font-size: 14px;
          }
        }
      }
    }
    .learning-statistics-content {
      .analysis-content {
        height: 128px;
        border-bottom: 2px solid #E1EBF6;
        display: flex;
        align-items: center;
        justify-content: space-around;
        .annular-panel {
          position: relative;
          display: flex;
          .panel-pie-chart {
            width: 56px;
            height: 56px !important;
            position: relative;
            .pie-chart {
              width: 100%;
              height: 100%;
              border-radius: 50%;
              background: conic-gradient(var(--start--color) var(--progress), var(--end--color) 0deg);
              position: relative;
              &::after {
                content: '';
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                width: 50%;
                height: 50%;
                border-radius: 50%;
                // background-color: #f5f8fd;
                background-color: #ffffff;
              }
            }
          }
          .panel-describe {
            font-family: PingFang SC;
            font-weight: 600;
            margin-left: 8px;
            text-align: left;
            .title {
              font-family: PingFang SC;
              font-size: 16px;
              margin-top: 4px;
            }
            .data {
              font-family: PingFang SC;
              font-size: 24px;
              margin-top: 3px;
            }
          }
        }
      }
      .task-table {
        height: 480px;
        .search-panel {
          text-align: left;
          padding: 16px 6px;
          .search-btn {
            display: inline-block;
            width: 60px;
            height: 32px;
            border-radius: 4px;
            cursor: pointer;
            border: 1px solid #D0DFFB;
            color: #0052D9;
            font-family: PingFang SC;
            font-size: 14px;
            line-height: 30px;
            margin-left: 2px;
            text-align: center;
          }
          /deep/ .el-form-item {
            margin-bottom: 0px;
          }
          /deep/ .el-input__inner {
            font-family: PingFang SC;
            width: 328px;
            height: 32px;
            border: 1px solid #D0DFFB;
            // color: #AAB4D2;
          }
          /deep/ .el-select {
            .el-input__inner {
              width: 160px;
              border-radius: 4px;
              color: #4F6389;
            }
          }
        }
        .table-study-detail {
          padding: 0 16px;
          .table-charts-panel {
            height: 44px;
            // border: 1px solid black;
            display: flex;
            align-items: center;
            justify-content: center;
            .table-pie-chart {
              width: 26px;
              height: 26px !important;
              position: relative;
              .pie-chart {
                width: 100%;
                height: 100%;
                border-radius: 50%;
                background: conic-gradient(#366EF4 var(--progress), #c5d2fa 0deg);
                position: relative;
                &::after {
                  content: '';
                  position: absolute;
                  top: 50%;
                  left: 50%;
                  transform: translate(-50%, -50%);
                  width: 50%;
                  height: 50%;
                  border-radius: 50%;
                  // background-color: #f5f8fd;
                  background-color: #ffffff;
                }
              }
            }
            .table-pie-data {
              font-size: 16px;
              color: #003CAB;
              margin-left: 8px;
              width: 60px;
              // text-align: left;
            }
            .table-bar-chart {
              width: 80px;
              height: 8px;
              border-radius: 4.5px;
              background: #daead1;
              .bar-chart {
                height: 100%;
                border-radius: 4.5px;
                background: #439613;
              }
            }
            .table-bar-data {
              font-size: 16px;
              color: #358C05;
              margin: 0 8px;
              width: 60px;
              // text-align: left;
            }
          }
        }
        .pagination-panel {
          margin: 12px 0;
          text-align: right;
          /deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
            background: #2B5EEF;
          }
          /deep/ .el-pagination.is-background .btn-next, /deep/ .el-pagination.is-background .btn-prev, /deep/ .el-pagination.is-background .el-pager li {
            border-radius: 8px;
          }
          /deep/ .el-pagination__jump {
            font-family: PingFang SC;
            font-size: 14px;
            margin-left: 14px;
          }
          /deep/ .el-pagination__total {
            font-family: PingFang SC;
            font-size: 14px;
          }
          /deep/ .el-pagination__sizes .el-input .el-input__inner {
            font-family: PingFang SC;
          }
        }
        /deep/ .el-table .el-table__cell {
          padding: 8px 0px;
          .cell {
            font-family: 'PingFang SC';
            font-size: 16px;
          }
        }
        /deep/ .el-table th.el-table__cell {
          padding: 6px 0px;
        }
      }
    }
    .exam-score-content {
      .score-table {
        // height: 137px;
        height: 287;
        padding: 16px;
        /deep/ .el-table .el-table__cell {
          .cell {
            font-family: 'PingFang SC';
            font-size: 16px;
          }
        }
        /deep/ .el-table th.el-table__cell {
          padding: 6px 0px;
        }
      }
    }
    .ai-evaluation-content {
      padding: 16px;
      min-height: 80px;
      .empty-tip {
        color: #999999;
        text-align: center;
        padding: 20px 0;
        font-family: PingFang SC;
        font-size: 14px;
      }
      .ai-eval-streaming {
        display: flex;
        align-items: flex-start;
        .ai-eval-cursor {
          margin-left: 2px;
          color: #0052D9;
          font-weight: bold;
          animation: ai-blink 1s steps(2, start) infinite;
        }
      }
      .ai-eval-error {
        color: #F5222D;
        font-family: PingFang SC;
        font-size: 14px;
      }
      .ai-eval-content {
        font-size: 15px;
        line-height: 1.6;
        color: #333333;
        white-space: pre-wrap;
        word-break: break-all;
        font-family: PingFang SC;
        text-align: left;
      }
    }
    @keyframes ai-blink {
      0% { opacity: 1; }
      50% { opacity: 0; }
      100% { opacity: 1; }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/classCenter/StudyDetails/index.vue